<template>
  <div
    class="main-nav-bottom-banner"
    v-if="renderData.bannerList?.length"
    ref="refBannerList"
    :class="{
      'main-nav-bottom-banner-only-one': renderData.bannerList.length == 1,
      [`main-nav-bottom-banner-${props.type}`]: true,
    }"
  >
    <el-carousel
      trigger="click"
      :autoplay="true"
      v-if="renderData.ifRender"
      :height="props.type == 'pc' ? '100px' : renderData.renderHeight"
    >
      <el-carousel-item
        v-for="item in renderData.bannerList"
        :key="item"
        @click="
          () => {
            goBannerItem(item);
          }
        "
      >
        <div
          class="main-nav-bottom-banner-item pointer"
          :style="{
            backgroundImage: `url(${getObjectStorageFullUrl(
              props.type == 'pc' ? item.url_pc : item.url_h5
            )}。)`,
            backgroundSize: '100% 100%',
          }"
        ></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import { useRouter, useRoute } from "vue-router";
import useUserDataStore from "@/store/userDataStore.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const userDataStore = useUserDataStore();
const Router = useRouter();
const route = useRoute();

const props = defineProps({
  type: {
    type: String,
    default: "pc",
  },
});
const emits = defineEmits([]);
const refBannerList = ref(null);
const renderData = reactive({
  bannerList: null,
  renderHeight: "0px",
  ifRender: true,
});

const goBannerItem = (item) => {
  globalProperties.logClickEvent(`catalog_banner`);
  if (item.blank_url.includes("special-christmas-gift")) {
    globalProperties.logClickEvent(`activity_banner`, {
      activity_name: "christmas_lip",
    });
    const queryString = item.blank_url.split("?")[1];
    const query = queryString ? queryString.split("&").reduce((acc, param) => {
      const [key, value] = param.split("=");
      if (key && value) {
        acc[key] = decodeURIComponent(value);
      }
      return acc;
    }, {}) : {}
    Router.push({
      name: 'createVideo',
      query
    });
  } else {
    window.open(item.blank_url, "_blank");
  }
};
const reRender = () => {
  renderData.ifRender = false;
  nextTick(() => {
    renderData.ifRender = true;
  });
};
const setBannerList = () => {
  // renderData.bannerList =
  //   userDataStore.bannerList?.filter((item) => {
  //     if (props.type == "pc") {
  //       return !item.app?.includes("h5");
  //     } else {
  //       return item.app?.includes("h5");
  //     }
  //   }) ?? [];
  renderData.bannerList = userDataStore.bannerList || [];
  nextTick().then(() => {
    if (renderData.bannerList?.length && props.type == "mobile") {
      renderData.renderHeight =
        Math.ceil(refBannerList.value?.offsetWidth / 3.5) + "px";
    }
    reRender();
  });
};
watch(
  () => {
    return userDataStore.bannerList;
  },
  () => {
    setBannerList();
  }
);

const initResizeObserve = () => {
  renderData.resizeObserver = new ResizeObserver(() => {
    setBannerList();
  });
  renderData.resizeObserver?.observe(document.body);
};

onMounted(() => {
  initResizeObserve();
  setBannerList();
});
onUnmounted(() => {
  renderData.resizeObserver?.disconnect();
});
</script>
<style lang="scss">
.main-nav-bottom-banner {
  border-radius: 8px;
  opacity: 1;
  padding: 0 16px 0 16px;
  width: 100%;
  max-width: 100%;
  .el-carousel__arrow {
    height: 20px;
    width: 20px;
    background: rgba(0, 0, 0, 0.2);
    z-index: 1;
    &.el-carousel__arrow--left {
      left: 6px;
    }
    &.el-carousel__arrow--right {
      right: 6px;
    }
  }
  .el-carousel__item {
    border-radius: 0;
    background: transparent;
  }
  .el-carousel__container {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
  }
  .el-carousel__indicators {
    z-index: unset;
    bottom: 6px;
    left: 50%;
    transform: translateX(-50%) translateY(0);
    height: 8px;
    line-height: 4px;
    padding: 0;
    li {
      width: 7px;
      height: 4px;
      border-radius: 5px;
      background: transparent;
      padding: 0;
      opacity: 1;
      margin: 0 2px;
      button {
        height: 100%;
        width: 100%;
        border-radius: 5px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.5);
      }
      &.is-active {
        width: 12px;
        background: #fff;
      }
    }
  }
  &.main-nav-bottom-banner-only-one {
    .el-carousel__indicators {
      display: none;
    }
    .el-carousel__arrow {
      display: none;
    }
  }
  .main-nav-bottom-banner-item {
    height: 100%;
    width: 100%;
    border-radius: 0;
    background-color: rgba(255, 255, 255, 0.2);
  }
  &.main-nav-bottom-banner-mobile {
    padding: 0;
    .el-carousel__container {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
    }
    .el-carousel__indicators {
      display: flex !important;
    }
    .el-carousel__arrow {
      height: 24px;
      width: 24px;
      display: flex !important;
      transform: translateY(-50%) !important;
      opacity: 1 !important;
      &.el-carousel__arrow--left {
        left: 12px !important;
      }
      &.el-carousel__arrow--right {
        right: 12px !important;
      }
    }
    .el-carousel__item {
      border-radius: 0;
    }
    .main-nav-bottom-banner-item {
      border-radius: 0;
    }
    &.main-nav-bottom-banner-only-one {
      .el-carousel__indicators {
        display: none !important;
      }
      .el-carousel__arrow {
        display: none !important;
      }
    }
  }
}
</style>
